import axios from 'axios'
import store from '@/store/store'
import router from '../router/'

function parseJwt (token) {
  let base64Url = token.split('.')[1]
  let base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(window.atob(base64))
};

export default () => {
  const ax = axios.create({
    // baseURL: `https://localhost:9004/api`,
    baseURL: `https://recursos.salesianosburgos.com/api`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
  ax.interceptors.response.use((response) => {
    // Do something with response data
    return response
  }, (error) => {
    if (error.response.status === 403 && error.response.data.msg === 'No tienes permiso para acceder') {
      let time = new Date().getTime()
      if (store.state.token && (parseJwt(store.state.token).exp < time)) {
        store.dispatch('setToken', '')
        store.dispatch('setUser', '')
        store.dispatch('setError', 'Sesión expirada')
        router.push({
          name: 'signin'
        })
      }
    }
    // Do something with response error
    return Promise.reject(error)
  })

  return ax
}



// WEBPACK FOOTER //
// ./src/services/Api.js